module.exports = __webpack_public_path__ + "static/media/quiz-2.3c796ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quiz-2.png
// module id = 129
// module chunks = 0